import { createSlice } from '@reduxjs/toolkit';
import { httpPost } from '../../util/Rest';
import { DEBTOR } from '../../constants/MicroServiceConstants';

const initialData = {
  accountNotesData: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'AccountNotes',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getAccountNotesData: (state, action) => {
      state.accountNotesData = action.payload.resultObjects;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const { getAccountNotesData, fetchStart, fetchError } = slice.actions;

export const fetchAccountNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/find/all/notes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getAccountNotesData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
